import {
  Commission,
  CommissionConfigScope,
  CommissionsSemantics,
} from "models/commissions"

import { http } from "./http"

export const fetchCommissions = async (
  _key: string,
  configScope?: CommissionConfigScope,
  configOwnerId?: string,
) => {
  const searchParams = new URLSearchParams()
  !!configScope && searchParams.set("configScope", configScope)
  !!configOwnerId && searchParams.set("configOwnerId", configOwnerId)
  const { data } = await http
    .get(`commissions`, { searchParams })
    .json<{ data: Commission[] }>()
  return data
}

export const createCommission = async (pld: Partial<Commission>) => {
  const json = pld
  const res = await http.post("commissions", { json }).json()
  return res as Commission
}

export const patchCommission = async (pld: Commission): Promise<Commission> => {
  const { id, ...data } = pld
  const res = await http.patch(`commissions/${pld.id}`, { json: data }).json()
  return res as Commission
}

export const deleteCommission = async (id: string) =>
  await http.delete(`commissions/${id}`)

export const fetchMediaPlanAvailableCommissions = async (
  _key: string,
  planId: string,
  params: string,
) => {
  const searchParams = new URLSearchParams(params)
  const { data } = await http
    .get(`media-plans/${planId}/commissions`, { searchParams })
    .json<{ data: Commission[] }>()

  return data
}

export const fetchCommissionsSemantics = async (
  _key: string,
  scope: Partial<CommissionConfigScope>,
) => {
  const searchParams = new URLSearchParams()
  !!scope && searchParams.set("scope", scope)
  const { data } = await http
    .get(`commissions/semantics`, { searchParams })
    .json<{ data: CommissionsSemantics[] }>()
  return data
}
